// tslint:disable:variable-name

export class RemoteObject {
    public id: string = '-1';
    public updatedAt: Date = new Date();
    public createdAt: Date = new Date();

    public remoteObjectCommonsFromJSON(json: any) {
        Object.getOwnPropertyNames(this).forEach((propertyName) => {
            if (propertyName === 'createdAt' || propertyName === 'updatedAt') {
                this[propertyName] = new Date(json[propertyName]);
            } else {
                this[propertyName] = json[propertyName];
            }
        });
    }

    public remoteObjectCommonsToJson(object: any) {
        Object.getOwnPropertyNames(this).forEach((propertyName) => {
            object[propertyName] = this[propertyName];
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/features/shared/model/remote-object.model.ts